import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createConversation } from '../../../data/statsAssistant'
import { UserFriendlyError } from '../../../model/Error'
import { upsertConversationSummary } from './statsAssistant.utils'

type CreateConversationVariables = {
  agentProfile?: string
  title?: string
}

export const useCreateConversation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (variables: CreateConversationVariables = {}) => {
      const { data, ok } = await createConversation(variables)
      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          'Impossible de créer une conversation',
          'Une erreur technique s’est produite',
        )
      }
      return data
    },
    onSuccess: (created) => {
      upsertConversationSummary(queryClient, {
        ...created,
        updatedAt: new Date().toISOString(),
        lastMessagePreview: null,
        isProcessing: false,
      })
    },
  })
}
